/**
 * Checks if a contact is a director.
 */
export function isDirectorContact(
  contact: { rol?: string[]; cargo?: string }
): boolean {
  const hasCargo = contact.cargo && contact.cargo.trim().length > 0;
  return !!hasCargo;
}

/**
 * Checks if a contact is a shareholder.
 */
export function isShareholderContact(
  contact: { rol?: string[]; porcentaje_beneficio?: number }
): boolean {
  const hasShareholdingPercentage =
    contact.porcentaje_beneficio !== undefined &&
    contact.porcentaje_beneficio !== null &&
    contact.porcentaje_beneficio > 0;
  return Boolean(hasShareholdingPercentage);
}